/**
 * COPIED from pages/dev-agent/components/metadataEditor/monacoLanguage.ts (no store coupling).
 * Monaco language id from file name + Salesforce metadata type.
 */
export const MIN_EDITOR_WIDTH = 450;
export const MAX_EDITOR_WIDTH = 900;

export function getMonacoLanguage(fileName: string, metadataType?: string): string {
  const parts = fileName.split(".");
  const ext = parts.length > 1 ? parts.pop()?.toLowerCase() : undefined;
  const EXT_MAP: Record<string, string> = {
    cls: "apex",
    trigger: "apex",
    xml: "xml",
    html: "html",
    cmp: "html",
    page: "html",
    component: "html",
    js: "javascript",
    ts: "typescript",
    css: "css",
    json: "json",
  };
  if (ext && EXT_MAP[ext]) return EXT_MAP[ext];

  if (metadataType) {
    const mt = metadataType.toLowerCase();
    if (mt.includes("apex") || mt === "apexclass" || mt === "apextrigger") return "apex";
    if (mt.includes("lightning") || mt.includes("lwc") || mt.includes("aura")) return "javascript";
    if (mt.includes("visualforce") || mt === "apexpage" || mt === "apexcomponent") return "html";
    if (mt.includes("custom") || mt.includes("flow") || mt.includes("flexi")) return "xml";
  }

  return "apex";
}
